exports.ApplyPageView = require('./ApplyPageView').default;
